import swal from 'sweetalert';
import Cookies from 'js-cookie';

document.addEventListener("DOMContentLoaded", function() {

	if(!document.body.hasAttribute('data-bt_tyres_enquirable')) {

		document.addEventListener('click', function (event) {

			// If the clicked element isn't the enquire button, return
			if ( ! event.target.matches('.enquire-button')) return;

			event.preventDefault();

			let tyre_modal = document.getElementById('tyre-contact');
			let tyre = (event.target).closest('.tyre-item');

			//if we have a tyre modal
			if(tyre_modal) {

				//if we don't have a tyre...
				if(!tyre) {

					//see if we can find an agriculture item instead
					tyre = (event.target).closest('.agriculture-item');
				}

				//trigger the enquiry modal
				open_enquire(tyre_modal, tyre, (event.target));
			}

		}, false);

		document.addEventListener('click', function (event) {

			if (event.target.matches('#close-enquire')) {

				let tyre_modal = document.getElementById('tyre-contact');
				let preview = document.getElementById('tyre-contact-preview');

				//if we have access to our tyre modal
				if(tyre_modal) {

					close_enquire(tyre_modal, preview);
				}
			}
		}, false);

		document.addEventListener('keydown', function(event) {

			//if the escape key has been pressed and the make an enquiry modal is open
			if((event.code == "Escape" || event.code == "Esc") && document.getElementById('tyre-contact').classList.contains('active')) {
				document.getElementById('tyre-contact').classList.remove('active');
			}


		}, false);

		document.body.setAttribute('data-bt_tyres_enquirable', true);

	}
});

export function open_enquire(tyre_modal, tyre, trigger = false) {

    //add the hidden class by default...
    tyre_modal.classList.add('preview-hidden');

	//if we have a tyre (either commercial or agricultural) to preview
	if(tyre) {

        //if we have a tyre and this isn't the cart...
        if(tyre && !document.body.classList.contains('page-template-page-cart')) {

            //remove the hidden class from the preview (if present)
            tyre_modal.classList.remove('preview-hidden');
        }

        let preview = document.getElementById('tyre-contact-preview');
		let tyre_field = tyre_modal.querySelector('input[name="tyre"]');
		let tyre_ref_field = tyre_modal.querySelector('input[name="tyre_ref"]');
		let tyre_stock_code_field = tyre_modal.querySelector('input[name="tyre_stock_code"]');
		let tyre_ipc_field = tyre_modal.querySelector('input[name="tyre_ipc"]');
		let tyre_quantity_field = tyre_modal.querySelector('input[name="tyre_quantity"]');
		let tyre_run_flat_field = tyre_modal.querySelector('input[name="tyre_run_flat"]');
		let fulfillment_field = tyre_modal.querySelector('input[name="fulfillment_method"]');

		let stock_level = tyre_modal.querySelector('input[name="stock_level"]');

		let tyre_price_field = tyre_modal.querySelector('input[name="tyre_price"]');
		let tyre_price_multibuy_field = tyre_modal.querySelector('input[name="tyre_price_multibuy"]');

		let tyre_price_combo = tyre_modal.querySelector('input[name="tyre_price_quantity_combo"]');

		let call_out_charge_field = tyre_modal.querySelector('input[name="call_out_charge"]');

        let nearest_branch_field = tyre_modal.querySelector('select[name="nearest_branch"]');

        let confirmation_text = tyre_modal.querySelector('#tyre-confirmation');

		//defines default prices and quantities
		let price = 'N/A';
		let price_multibuy = 'N/A';
		let price_combo = 'N/A';
		let quantity = 0;

		let additional_costs_text = '';
		let additional_costs = 0;

		//if we have a tyre field inside the form
		if(tyre_field) {

			//add the tyre's name into it
			tyre_field.value = tyre.dataset.name;
		}

		//if we have a tyre reference field inside the form and we have some data to put in it
		if(tyre_ref_field && typeof tyre.dataset.description != 'undefined') {

			//add the tyre's name into it
			tyre_ref_field.value = tyre.dataset.description;
		}

		//if we have a tyre stock code field inside the form and we have some data to put in it
		if(tyre_stock_code_field && typeof tyre.dataset.stock_code != 'undefined') {

			//add the tyre's name into it
			tyre_stock_code_field.value = tyre.dataset.stock_code;
		}

		//if we have a tyre ipc field inside the form and we have some data to put in it
		if(tyre_ipc_field && typeof tyre.dataset.ipc != 'undefined') {

			//add the tyre's name into it
			tyre_ipc_field.value = tyre.dataset.ipc;
		}

		//if we have a tyre run_flat field inside the form and we have some data to put in it
		if(tyre_run_flat_field && typeof tyre.dataset.run_flat != 'undefined') {

			//add the tyre's name into it
			tyre_run_flat_field.value = tyre.dataset.run_flat;
		}

        //fetch our default fulfillment type
		let fulfillment_type = (tyres_ajax_object.delivery_allowed == 'true') ? 'home_delivery' : 'branch_fitting';

        //if we have a cookie set for the fulfillment type
        if(Cookies.get('bt_fulfillment_type')) {

            //set the fulfillment type from the cookie
            fulfillment_type = Cookies.get('bt_fulfillment_type');
        }

        //attempt to fetch the currently selected fulfillment type for this tyre
        let selected_fulfilment_type = tyre.querySelector('input[name^="delivery-type"]:checked');

        //if we have a fulfillment field inside the form
        if(fulfillment_field) {

            //add the users's fulfillment type from the field if it exists
            fulfillment_field.value = (selected_fulfilment_type && typeof selected_fulfilment_type.value !== 'undefined') ? selected_fulfilment_type.value : fulfillment_type;
        }

        //if we have a fulfillment type and a selected fulfillment type
        if(fulfillment_type) {

            //update the fulfilment type variable from the field if it exists
            fulfillment_type = (selected_fulfilment_type && typeof selected_fulfilment_type.value !== 'undefined') ? selected_fulfilment_type.value : fulfillment_type;
        }

        // Create a new 'change' event
        var event = new Event('change');

        //if we have a fulfillment field inside the form
        if(fulfillment_field) {

            // Dispatch it to trigger FF conditional rendering
            fulfillment_field.dispatchEvent(event);
        }

		//if we have a tyre quantity field inside the form
		if(tyre_quantity_field) {

			//fetch the quantity field
			quantity = tyre.getElementsByClassName('qty');

			//if we have a quantity field to pull from
			if(quantity && quantity[0]) {

				//swap the quantity for a single value
				quantity = quantity[0].value;

				//if we somehow have a quantity of 1 and we're doing mobile fitting
				if((quantity === 1 || quantity === '1') && fulfillment_type === 'mobile_fitting') {

					//force the quantity to 2
					quantity = 2;

                    //notify the user that we've changed their quantity
                    swal({
                        title: "We've changed your quantity",
                        text: "Our mobile fitting service requires a minimum of two tyres to be fitted. We've changed your quantity to two.",
                        timer: 6000
                    });
				}

				//add the quantity across to our hidden field
				tyre_quantity_field.value = quantity;
			}
		}

		//if we have a fulfillment type and tyre price field inside the form
		if(fulfillment_type && (tyre_price_field || tyre_price_multibuy_field)) {

			//fetch all tyre prices
			let prices = tyre.getElementsByClassName('tyre-price');

			//if we have some prices to loop through
			if(prices && prices.length > 0) {

				//loop over each price
				for(let i = 0; i < prices.length; i++) {

					//if this price matches our fulfillment type
					if(prices[i].dataset.type === fulfillment_type) {

                        //gets all span elements within the price element
						let price_elem = prices[i].getElementsByTagName('span');

						if(price_elem && typeof price_elem[0] != 'undefined') {

							//if we have a unit price attribute
							if(typeof price_elem[0].dataset.unit_price != 'undefined') {

								//set the unit price
								price = parseFloat(price_elem[0].dataset.unit_price);
							}

							//if we have a multibuy price attribute
							if(typeof price_elem[0].dataset.unit_multibuy_price != 'undefined') {

								//set the multibuy price
								price_multibuy = parseFloat(price_elem[0].dataset.unit_multibuy_price);
							}

							//if we have an additional cost attribute
							if(typeof price_elem[0].dataset.additional_costs != 'undefined') {

								//set the additional cost
								additional_costs = parseFloat(price_elem[0].dataset.additional_costs).toFixed(2);

								//if we have some matching additional text too
								if(typeof price_elem[0].dataset.additional_costs_text != 'undefined') {

									//set the additional text
									additional_costs_text = price_elem[0].dataset.additional_costs_text;
								}
							}
						}

                        //if we don't have a price or a multibuy price
                        if(price == 'N/A' && price_multibuy == 'N/A') {

                            //if we have a price on the element itself...
                            if(typeof prices[i].dataset.price != 'undefined') {

                                //set the price
                                price = (prices[i].dataset.price);
                            }

                            //if we have a multibuy price on the element itself...
                            if(typeof prices[i].dataset.price_multibuy != 'undefined') {

                                //set the price
                                price_multibuy = (prices[i].dataset.price_multibuy);
                            }
                        }
					}
				}
			}

			//if we have a unit price field
			if(tyre_price_field) {

				//apply it using the price we've found
				tyre_price_field.value = !isNaN(price) ? ('£' + price) : 'POA';
			}

			//if we have a multibuy price field
			if(tyre_price_multibuy_field) {

				//apply it using the multibuy price we've found
				tyre_price_multibuy_field.value = !isNaN(price_multibuy) ? ('£' + price_multibuy) : 'POA';
			}

			//if this form has a callout field
			if(call_out_charge_field) {

				//make it N/A for now
				call_out_charge_field.value = 'N/A';
			}

			//if we have a quantity and a combo field to output to
			if(tyre_quantity_field && tyre_price_combo) {

				//combine the price and the quantity, maintaining two decimal points
				price_combo = parseFloat(price * quantity).toFixed(2);

				//if the quantity is greater than or equal to 4 and we have a multibuy price - our multibuy applies
				if(quantity >= 4 && price_multibuy) {

					//combine the multibuy price and the quantity, maintaining two decimal points
					price_combo = parseFloat(price_multibuy * quantity).toFixed(2);
				}

				//if we have a fitting cost and it's not equal to nothing
				if(additional_costs && additional_costs != 0) {

					//depending on the fulfilment type we need to make alterations
					switch(fulfillment_type) {

						//if this is for branch fitting
						case 'branch_fitting':

							//multiply the fitting cost by the quantity, maintaining two decimal points
							additional_costs = parseFloat(additional_costs * quantity).toFixed(2);
						break;

						//if this is for mobile fittings
						case 'mobile_fitting':

							//if this form has a callout field and we have additional costs
							if(call_out_charge_field && additional_costs) {

								//add our call out charge
								call_out_charge_field.value = '£' + additional_costs;
							}
						break;
					}
				}

				//set this as the value of the combo field (with a label indicating multibuy status)
				tyre_price_combo.value = !isNaN(price_combo) ? ('£' + price_combo + (additional_costs ? (' ' + additional_costs_text.replace('$i', additional_costs)) : '') + (quantity >= 4 ? ' (incl. multibuy discount)' : '')) : 'POA';
			}
		}

		//if we have a limited stock enquiry field and we've been passed the trigget, we can check for limited stock
		if(trigger && stock_level) {

			//if we have a limited stock data attribute
			if(typeof trigger.dataset.stock_level != 'undefined') {

				//add the limited stock value to the modal
				stock_level.value = trigger.dataset.stock_level;
			}
		}

        //if we have a nearest branch field
        if(nearest_branch_field) {

            //create a new change event to ensure primary/secondary emails are distributed correctly
            let event = new Event('change');

            //dispatch the event
            nearest_branch_field.dispatchEvent(event);
        }

        //if we have a confirmation text element
        if(confirmation_text && (quantity && tyre_field && fulfillment_type && tyre_price_combo)) {

            //add our instruction text
            confirmation_text.innerHTML = "<strong class='block'>Please review...</strong>";

            //update the confirmation text
            confirmation_text.innerHTML += "You've selected <strong>x" + quantity + " " + tyre_field.value + "</strong> for " + fulfillment_type.replace(/_/g, ' ') + " at <strong>" + tyre_price_combo.value + "</strong>";

            //remove the hidden class (if present)
            confirmation_text.classList.remove('hidden');
        }

		try {
			//if we have space for a tyre preview
			if(preview) {

				//clear preview
				preview.innerHTML = '';

				//if this is a child page's first display area
				if(tyre.classList.contains('is-child-display')) {
					tyre = tyre.nextElementSibling;
				}

				//clone the tyre we're looking at
				let clone = tyre.cloneNode(true);

				//if we've got a cloned copy
				if(clone) {

                    //remove list view class
                    clone.classList.remove('list-tyre-item');

					//append it to the preview
					preview.appendChild(clone);
				}
			}
		} catch(e) {
			console.log(e);
		}
	}

	//show the modal
	tyre_modal.classList.add('active');

	setTimeout(function() {
		document.getElementById('close-enquire').focus();
	}, 300);
}

function close_enquire(tyre_modal, preview) {

	//remove the active class
	tyre_modal.classList.remove('active');

	//remove the limited stock class (if present)
	tyre_modal.classList.remove('limited-stock');

	if(preview) {

		//attempt to get the preview item
		let tyre = preview.querySelector('.tyre-item');
		let tyre_id = false;

		//if we have a tyre
		if(tyre) {

			//save its ID
			tyre_id = tyre.dataset.stock_code;
		}

		//empty the preview
		preview.innerHTML = '';

		//if we have a tyre ID
		if(tyre_id) {

			//attempt to fetch the original tyre (in the loop)
			let original_tyre = document.querySelector('.tyre-item[data-stock_code="' + tyre_id + '"]');

			//if we have access to the original tyre
			if(original_tyre) {

				//find the target toggle
				let target_fulfilment_toggle = original_tyre.querySelector('input[name^="delivery-type"][value="' + document.body.dataset.fulfilment_type + '"]');

				//if we have a target toggle
				if(target_fulfilment_toggle) {

					//toggle this input
					target_fulfilment_toggle.checked = true;
				}
			}
		}
	}
}